import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import { withRouter } from 'react-router'

import { Query } from 'react-apollo'

import { SELECTED_BRANCH } from '../constants'
import { BRANCH_QUERY, BRANCH_HISTORY_QUERY } from '../queries'

import Dashboard from '../views/Dashboard/'
import Confirmation from '../views/Confirmation/'
import Assortiment from '../views/Assortiment/'
import Packages from '../views/Packages/'
import Faults from '../views/Faults/'
import Contact from '../views/Contact/'
import CompanyDetails from '../views/CompanyDetails/'
import Agenda from '../views/Agenda/'
import OrderList from '../views/OrderList/'
import OrderHistory from '../views/OrderHistory/'
import OldOrderList from '../views/OldOrderList/'
import CompanyMembers from '../views/CompanyMembers/'
import EditMember from '../views/EditMember/'
import Settings from '../views/Settings/'
import ShoppingCart from '../views/ShoppingCart/'
import Invoices from '../views/Invoices/'
import Documents from '../views/Documents/'
import FAQ from '../views/FAQ/'
import Loader from '../components/Loader'
import Error from '../components/Error'
import Logout from '../views/Logout'

class AuthenticatedRoutes extends Component {
  render() {
    const branchId = window.localStorage.getItem(SELECTED_BRANCH)
      ? window.localStorage.getItem(SELECTED_BRANCH)
      : window.sessionStorage.getItem(SELECTED_BRANCH)
    return (
      <Query query={BRANCH_QUERY} variables={{ id: branchId }}>
        {({ loading, error, data }) => {
          console.log(error)
          if (loading) return <Loader from="0%" to="25%" fixed />
          if (error) return <Error error="de bedrijfsgegevens" />

          const { branch } = data
          let orderId = branch.orders.length ? branch.orders[0].id : null
          const deliveryId = branch.deliveries.length ? branch.deliveries[0].id : null
          let portalOrderId = branch.portalOrders.length ? branch.portalOrders[0].id : null
          let code =  branch.portalOrders.length ?  branch.portalOrders[0].code : null

          return (
            <Switch>
              <Route
                exact
                path="/"
                render={props => (
                  <Dashboard
                    branchName={branch.name}
                    {...props}
                    orderId={orderId}
                    portalOrderId={portalOrderId}
                    deliveryId={deliveryId}
                    setLoading={this.setLoading}
                    order={branch.orders.length ? branch.orders[0] : null}
                    delivery={branch.deliveries.length ? branch.deliveries[0] : null}
                    portalOrder={branch.portalOrders.length ? branch.portalOrders[0] : null}
                    errors={branch.errorMessages.length ? branch.errorMessages : null}
                    messages={branch.contactMessages.length ? branch.contactMessages : null}
                    servicePackage={branch.servicePackage}
                    suspended={branch.suspended}
                    nextDeliveryDate={branch.nextDeliveryDate}
                  />
                )}
              />
              <Route
                exact
                path="/assortiment/koffie"
                render={props => (
                  <Assortiment
                    product="Koffie"
                    {...props}
                    orderId={orderId}
                    portalOrderId={portalOrderId}
                    deliveryId={deliveryId}
                    branchName={branch.name}
                    suspended={branch.suspended}
                  />
                )}
              />
              <Route
                exact
                path="/assortiment/thee"
                render={props => (
                  <Assortiment
                    product="Thee"
                    {...props}
                    orderId={orderId}
                    portalOrderId={portalOrderId}
                    deliveryId={deliveryId}
                    branchName={branch.name}
                    suspended={branch.suspended}
                  />
                )}
              />
              <Route
                exact
                path="/assortiment/food"
                render={props => (
                  <Assortiment
                    product="Food"
                    {...props}
                    orderId={orderId}
                    portalOrderId={portalOrderId}
                    deliveryId={deliveryId}
                    branchName={branch.name}
                    suspended={branch.suspended}
                  />
                )}
              />
              <Route
                exact
                path="/assortiment/non-food"
                render={props => (
                  <Assortiment
                    product="Non-food"
                    {...props}
                    orderId={orderId}
                    portalOrderId={portalOrderId}
                    deliveryId={deliveryId}
                    branchName={branch.name}
                    suspended={branch.suspended}
                  />
                )}
              />
              <Route
                exact
                path="/storing-melden"
                render={props => (
                  <Faults {...props} orderId={orderId} deliveryId={deliveryId} portalOrderId={portalOrderId} branchName={branch.name} branch={branch} suspended={branch.suspended} />
                )}
              />
              <Route
                exact
                path="/storing-melden/bedankt"
                render={props => (
                  <Confirmation
                    {...props}
                    orderId={orderId}
                    deliveryId={deliveryId}
                    portalOrderId={portalOrderId}
                    branchName={branch.name}
                    suspended={branch.suspended}
                    content={{
                      header: 'Storing gemeld',
                      title: 'Uw storing is gemeld.',
                      firstLine:
                        'Het kan zijn dat een van onze technici telefonisch contact met u opneemt.',
                      secondLine: 'We zorgen dat u snel weer van uw machine gebruik kunt maken.'
                    }}
                  />
                )}
              />
              <Route
                exact
                path="/contact"
                render={props => (
                  <Contact {...props} orderId={orderId} portalOrderId={portalOrderId} deliveryId={deliveryId} branchName={branch.name} suspended={branch.suspended} />
                )}
              />
              <Route
                exact
                path="/contact/bedankt"
                render={props => (
                  <Confirmation
                    {...props}
                    orderId={orderId}
                    deliveryId={deliveryId}
                    portalOrderId={portalOrderId}
                    branchName={branch.name}
                    suspended={branch.suspended}
                    content={{
                      header: 'Bericht verzonden',
                      title: 'Dank voor uw bericht.',
                      firstLine:
                        'Op onze afdeling gaat er nu een belletje rinkelen. Houd uw telefoon in de gaten, we spreken elkaar snel.',
                      secondLine: ''
                    }}
                  />
                )}
              />
              <Route
                exact
                path="/mijn-bedrijf/bedrijfsgegevens"
                render={props => (
                  <CompanyDetails
                    {...props}
                    branchName={branch.name}
                    orderId={orderId}
                    deliveryId={deliveryId}
                    portalOrderId={portalOrderId}
                    branch={branch}
                    branchId={branchId}
                    suspended={branch.suspended}
                  />
                )}
              />
              <Route
                exact
                path="/bestellijst"
                render={props => (
                  <OrderList
                    {...props}
                    orderId={orderId}
                    portalOrderId={portalOrderId}
                    deliveryId={deliveryId}
                    branchName={branch.name}
                    branchId={branch.id}
                    branch={branch}
                    nextDeliveryDate={branch.nextDeliveryDate}
                    servicePackage={branch.servicePackage}
                    order={branch.orders.length ? branch.orders[0] : null}
                    delivery={branch.deliveries.length ? branch.deliveries[0] : null}
                    portalOrder={branch.portalOrders.length ? branch.portalOrders[0] : null}
                    suspended={branch.suspended}
                  />
                )}
              />
              <Route
                exact
                path="/bestellijst/bedankt"
                render={props => (
                  <Confirmation
                    {...props}
                    orderId={orderId}
                    deliveryId={deliveryId}
                    branchName={branch.name}
                    portalOrderId={portalOrderId}
                    suspended={branch.suspended}
                    content={{
                      header: 'Bestelling geplaatst',
                      title: 'Uw bestelling wordt verwerkt.',
                      firstLine:
                        'Uw bestelling is verzonden. We gaan uw bestelling verwerken en inplannen. Het kan tot maximaal 10 minuten duren voordat uw bestelling zichtbaar is in het portaal. Zodra wij uw bestelling hebben ingepland wordt het levermoment zichtbaar in uw agenda.',
                      secondLine: `Heeft u vragen of opmerkingen over deze bestelling?<br/>Neem dan <a href="/contact">contact</a> op.`
                    }}
                  />
                )}
              />
              <Route
                exact
                path="/mijn-bedrijf/orderhistorie"
                render={props => (
                  <Query query={BRANCH_HISTORY_QUERY} variables={{ id: branchId }}>
                    {({ loading, error, data }) => {
                      if (loading) return <Loader from="0%" to="25%" fixed />
                      if (error) return <Error error="de orderhistorie" />
                      const { branch } = data
                      return (
                        <OrderHistory
                          {...props}
                          orderId={orderId}
                          portalOrderId={portalOrderId}
                          deliveryId={deliveryId}
                          branch={branch}
                          branchName={branch.name}
                          servicePackage={branch.servicePackage}
                          oldOrders={branch.oldOrders}
                          suspended={branch.suspended}
                        />
                      )
                    }}
                  </Query>
                )}
              />
              <Route
                exact
                path="/orderhistorie/:id"
                render={props => (
                  <OldOrderList {...props} code={code} orderId={orderId} portalOrderId={portalOrderId} deliveryId={deliveryId} branchName={branch.name} branchId={branch.id} branch={branch} suspended={branch.suspended} />
                )}
              />
              <Route
                exact
                path="/agenda"
                render={props => (
                  <Agenda
                    {...props}
                    orderId={orderId}
                    deliveryId={deliveryId}
                    portalOrderId={portalOrderId}
                    branchName={branch.name}
                    branch={branch}
                    order={branch.orders.length ? branch.orders[0] : null}
                    delivery={branch.deliveries.length ? branch.deliveries[0] : null}
                    portalOrder={branch.portalOrders.length ? branch.portalOrders[0] : null}
                    servicePackage={branch.servicePackage}
                    nextDeliveryDate={branch.nextDeliveryDate}
                    suspended={branch.suspended}
                  />
                )}
              />
              <Route
                exact
                path="/medewerkers"
                render={props => (
                  <CompanyMembers {...props} orderId={orderId} portalOrderId={portalOrderId} deliveryId={deliveryId} branchName={branch.name} branch={branch} />
                )}
              />
              <Route
                exact
                path="/medewerkers/:id/bewerken"
                render={props => (
                  <EditMember {...props} orderId={orderId} portalOrderId={portalOrderId} deliveryId={deliveryId} branchName={branch.name} branch={branch} />
                )}
              />
              <Route
                exact
                path="/instellingen"
                render={props => (
                  <Settings {...props} orderId={orderId} portalOrderId={portalOrderId} deliveryId={deliveryId} branchName={branch.name} branch={branch} />
                )}
              />
              <Route
                exact
                path="/servicepakketten"
                render={props => (
                  <Packages
                    {...props}
                    orderId={orderId}
                    deliveryId={deliveryId}
                    portalOrderId={portalOrderId}
                    branchName={branch.name}
                    branch={branch}
                    content={{
                      header: 'Servicepakketten'
                    }}
                  />
                )}
              />
              <Route
                exact
                path="/bestelling-plaatsen"
                render={props => (
                  <ShoppingCart
                    {...props}
                    orderId={orderId}
                    portalOrderId={portalOrderId}
                    deliveryId={deliveryId}
                    branchName={branch.name}
                    branchId={branch.id}
                    branch={branch}
                    nextDeliveryDate={branch.nextDeliveryDate}
                    servicePackage={branch.servicePackage}
                    order={branch.orders.length ? branch.orders[0] : null}
                    delivery={branch.deliveries.length ? branch.deliveries[0] : null}
                    portalOrder={branch.portalOrders.length ? branch.portalOrders[0] : null}
                  />
                )}
              />
              <Route
                exact
                path="/mijn-bedrijf/facturen"
                render={props => (
                  <Invoices
                    {...props}
                    orderId={orderId}
                    portalOrderId={portalOrderId}
                    deliveryId={deliveryId}
                    branchName={branch.name}
                    branchId={branch.id}
                    branch={branch}
                    order={branch.orders.length ? branch.orders[0] : null}
                    delivery={branch.deliveries.length ? branch.deliveries[0] : null}
                    portalOrder={branch.portalOrders.length ? branch.portalOrders[0] : null}
                    invoices={branch.invoices}
                    suspended={branch.suspended}
                  />
                )}
              />
              <Route
                exact
                path="/mijn-bedrijf/technische-gegevens"
                render={props => (
                  <Documents
                    {...props}
                    orderId={orderId}
                    portalOrderId={portalOrderId}
                    deliveryId={deliveryId}
                    branchName={branch.name}
                    branchId={branch.id}
                    branch={branch}
                    order={branch.orders.length ? branch.orders[0] : null}
                    delivery={branch.deliveries.length ? branch.deliveries[0] : null}
                    portalOrder={branch.portalOrders.length ? branch.portalOrders[0] : null}
                    documents={branch.docs}
                    suspended={branch.suspended}
                  />
                )}
              />
              <Route
                exact
                path="/faq"
                render={props => (
                  <FAQ
                    {...props}
                    orderId={orderId}
                    portalOrderId={portalOrderId}
                    deliveryId={deliveryId}
                    branchName={branch.name}
                    branchId={branch.id}
                    branch={branch}
                    order={branch.orders.length ? branch.orders[0] : null}
                    delivery={branch.deliveries.length ? branch.deliveries[0] : null}
                    portalOrder={branch.portalOrders.length ? branch.portalOrders[0] : null}
                    invoices={branch.invoices}
                    suspended={branch.suspended}
                  />
                )}
              />
              <Route
                exact
                path="/login"
                render={props => (
                  <Logout />
                )}
              />
              <Route path="/activeren/:id" render={props => <Logout />} />
              <Route path="/wachtwoord-vergeten/" render={props => <Logout />} />
              <Route path="/wachtwoord-resetten/:token" render={props => <Logout />} />
              <Route path="/proactive-login/" render={props => <Logout />} />
              <Route path="/axxerion-login/" render={props => <Logout />} />
              <Route path="/afas-login/" render={props => <Logout />} />
            </Switch>
          )
        }}
      </Query>
    )
  }
}

export default withRouter(AuthenticatedRoutes)



// WEBPACK FOOTER //
// ./src/App/AuthenticatedRoutes.js